import React from 'react'
import { func, object, oneOf } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { stores } from '../../../stores'
import { PagesPaths } from '../../../constants/Pages'
import './NewInquiryButton.css'

// A connected customer already gave us their postal code: reuse it so the
// funnel opens directly on their gardeners instead of asking again
const newInquiryPath = () => {
  const account = stores.account.connected
  const zipCode = account && account.address && account.address.zipCode
    ? String(account.address.zipCode).trim()
    : null
  return zipCode
    ? `${PagesPaths.INQUIRY.path}?search=${encodeURIComponent(zipCode)}`
    : PagesPaths.INQUIRY.path
}

const NewInquiryButtonComponent = ({ t, history, variant, onNavigate }) => (
  <button
    className={`new-inquiry ${variant ? `new-inquiry--${variant}` : ''}`}
    onClick={() => {
      if (onNavigate) onNavigate()
      history.push(newInquiryPath())
    }}>
    <span className='new-inquiry__plus' aria-hidden='true'>+</span>
    <span className='new-inquiry__label'>{t('common:visits:new_request')}</span>
  </button>
)

NewInquiryButtonComponent.propTypes = {
  t: func,
  history: object,
  variant: oneOf(['menu']),
  onNavigate: func
}

export const NewInquiryButton = withRouter(translate()(NewInquiryButtonComponent))



// WEBPACK FOOTER //
// ./src/components/ui/buttons/NewInquiryButton.js